import { render, staticRenderFns } from "./Singin.vue?vue&type=template&id=0abc4937"
import script from "./Singin.vue?vue&type=script&lang=js"
export * from "./Singin.vue?vue&type=script&lang=js"
import style0 from "./Singin.vue?vue&type=style&index=0&id=0abc4937&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports